<template>
  <div class="complex-wrap">
    <template v-for="child in props.dataSource.children">
      <div
        class="complex-item"
        v-if="child.isShowFn ? child.isShowFn(tbForm) : true"
        :key="child.name">
        <el-form-item
          :prop="child.name"
          :label="child.label"
          :rules="child.rules"
          :label-width="'12%'">
          <component
            :is="child.component.component"
            :props="child.component.props"
            @fieldChanged="specificationsFieldChanged"
            @file-upload="handleImageUpload"
          ></component>
            <div
              v-if="child.tipRule && child.tipRule.length"
              class="tips ft-12">
              <span
                style="display: block"
                v-for="(tip, tipIndex) in child.tipRule"
                v-html="tip"
                :key="tipIndex"></span>
            </div>
        </el-form-item>
      </div>
    </template>
  </div>
</template>

<script>
import storeMixins from '../store-mixins'

export default {
  mixins: [storeMixins],
  props: ['props'],
  computed: {
    key() {
      return this.props.name
    },
  },
  methods: {
    specificationsFieldChanged() {
      this.$emit('fieldChanged')
    },
    handleImageUpload(v) {
      this.$emit('file-upload', v);
    }
  }
};
</script>

<style lang="scss" scoped>
.complex-wrap {
  // background: #F9F9FA;
  // padding: 10px 20px;
  // display: flex;
  // flex-direction: row;
  // flex-wrap: wrap;
  // min-height: 100px;
  // align-items: flex-start;
  .complex-item {
    // width: 100%;
    margin-bottom: 20px !important;
  }

  // ::v-deep .el-form-item__label {
  //   padding: 0;
  // }
}
</style>